<template>
  <div class="page3 full-page">
    <!-- <h3 class="page3-shao-ani" :class="zhoren != 'zh' ?'isen':''">{{$t('page3title')}}</h3> -->
    <div class="page3-wrap">
      <h3>{{$t('page3title')}}</h3>
      <h4 v-if="zhoren == 'zh'">The inspection product category covers <span style="color: #FF5023;">26</span> fields</h4>
      <img v-if="zhoren=='zh'" class="category-bg" src="@/assets/images/category-bg.png" alt="">
      <img v-else class="category-bg" src="@/assets/images/category-bg-en.png" alt="">   
		<el-carousel style="width: 90%;" height="120px">
          <el-carousel-item v-for="item in imgList" :key="item">
            <img style="margin-right: calc((100% - 120px * 7)/7);width: 120px;" v-for="(pic, picIndex) in item" :key="picIndex" :src="item[picIndex]" alt="">
          </el-carousel-item>
        </el-carousel>
    </div>

    <div class="type-list-box">
      
    </div>
    <!-- <div class="btn-group">
      <router-link
        target="_blank"
        to="/index/MoreProducts"
        class="more hvr-float-shadow page3-shao-ani"
      >{{$t('page3btn')}}</router-link>
    </div> -->
  </div>
</template>

<script>
import { cateList } from "@/api/webIndex";
import $ from "jquery";
export default {
  name: "page3",
  data() {
    return {
      cateData: [],
      zhoren: localStorage.getItem("locale") || "zh",
	  //cbg:localStorage.getItem("locale")=='en'?"category-bg-en.png":"category-bg.png",
      imgList: [
        [
          require("@/assets/images/carousel/1.png"),
          require("@/assets/images/carousel/2.png"),
          require("@/assets/images/carousel/3.png"),
          require("@/assets/images/carousel/4.png"),
          require("@/assets/images/carousel/5.png"),
          require("@/assets/images/carousel/6.png"),
          require("@/assets/images/carousel/7.png"),
        ],
        [
          require("@/assets/images/carousel/8.png"),
          require("@/assets/images/carousel/9.png"),
          require("@/assets/images/carousel/10.png"),
          require("@/assets/images/carousel/11.png"),
          require("@/assets/images/carousel/12.png"),
          require("@/assets/images/carousel/13.png"),
          require("@/assets/images/carousel/14.png"),
          require("@/assets/images/carousel/15.png"),
        ],
        [
          require("@/assets/images/carousel/16.png"),
          require("@/assets/images/carousel/17.png"),
          require("@/assets/images/carousel/18.png"),
          require("@/assets/images/carousel/19.png"),
          require("@/assets/images/carousel/20.png"),
          require("@/assets/images/carousel/21.png"),
          require("@/assets/images/carousel/22.png"),
        ]
      ]
    };
  },
  methods: {
    // 跳转到对应子页面
    openSon(category_id) {
      const newObj = this.$router.resolve({
        path: "/index/MoreProducts",
        query: { category_id: category_id }
      });
      window.open(newObj.href, "_blank");
    },
    async getcateList() {
      let res = await cateList();
      const { data, code } = res.data;
      if (code == 200) {
        if (data instanceof Array) {
          this.cateData = data.map(item => {
            item.name = item.name || "空";
            item.name_en = item.name_en || "empty";
            return item;
          });
          this.cateData.forEach(item => {
            item.rate = item.rate.toFixed(2);
          });
        }
      }
    }
  },
  watch: {
    "$route.hash": {
      handler() {
        if (this.$route.hash === "#page3") {
          if (
            !$(".page3-shao-ani")
              .eq(0)
              .hasClass("animated")
          ) {
            $(".page3-shao-ani").css({ visibility: "hidden" });
          }

          setTimeout(function() {
            $(".page3-shao-ani")
              .eq(0)
              .css({ visibility: "visible" })
              .addClass("animated fadeInRightBig");
          }, 1000);
          setTimeout(function() {
            $(".page3-shao-ani")
              .eq(1)
              .css({ visibility: "visible" })
              .addClass("animated fadeInUp");
          }, 1500);
        }
      },
      immediate: true
    }
  },
  created() {},
  async mounted() {
    await this.getcateList();
  }
};
</script>

<style scoped lang="scss">
$width: 8.21px;
$vw: 19.2px;
.auto {
  display: block;
  margin: 0 auto;
}
.to-fadeUp {
  opacity: 1 !important;
  transform: translateY(0) !important;
}
.to-fadeLeft {
  opacity: 1 !important;
  transform: translateX(0) !important;
}
.page3 {
  width: 100%;
  height: 100%;
  background-color: #242A37;
  padding: 80px 0;
  box-sizing: border-box;
  overflow: hidden;
  color: #ffffff;
  .page3-wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h4 {
      font-size: 18px;
      font-family: FZLanTingHei-DB-GBK;
      font-weight: 400;
      color: #999999;
      margin-top: 20px;
    }
    .category-bg {
      width: 600px;
      // height: 621px;
      margin: 70px 0 83px 0;

    }
  }

  // .type-list-box {
  //   height: 600px / $vw * 1vw;
  //   min-width: 1300px;
  //   padding-top: 60px / $vw * 1vw;
  //   display: flex;
  //   justify-content: stretch;
  //   align-items: stretch;
  //   .leftbar {
  //     transform: translateX(45px / $vw * 1vw);
  //   }
  //   .leftbar,
  //   .rightbar {
  //     flex: 0 0 40%;
  //     display: flex;
  //     justify-content: flex-start;
  //     align-items: stretch;
  //     max-width: 40%;
  //     flex-direction: row-reverse;
  //     & > div {
  //       height: 100%;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //       flex-direction: column;
  //       font-size: 0;
  //       &:hover {
  //         z-index: 9999;
  //       }
  //       .item {
  //         transition: all 0.2s;
  //         &:hover {
  //           background-image: url("../../assets/fullpageImage/item-bg-active.png");
  //           transform: scale(1.5);
  //           z-index: 10;
  //           position: relative;
  //           & > div {
  //             transform: scale(0.7);
  //           }
  //           h4,
  //           h5,
  //           p {
  //             color: #fff !important;
  //             opacity: 1 !important;
  //           }
  //           h4 {
  //             border-bottom-color: #fff;
  //             white-space: normal;
  //             max-width: 100%;
  //             overflow: hidden;
  //             text-overflow: ellipsis;
  //             display: -webkit-box;
  //             -webkit-line-clamp: 2;
  //             -webkit-box-orient: vertical;
  //           }
  //         }
  //       }
  //       &:nth-of-type(1) {
  //         position: relative;
  //         left: 0;
  //         h4,
  //         h5 {
  //           color: #292929 !important;
  //           opacity: 1;
  //         }
  //       }
  //       &:nth-of-type(2) {
  //         position: relative;
  //         transform: scale(0.9);
  //         left: 52px / $vw * 1vw;
  //         .item:nth-of-type(2) {
  //           h4,
  //           h5 {
  //             color: #292929;
  //             opacity: 0.7;
  //           }
  //         }
  //       }
  //       &:nth-of-type(3) {
  //         position: relative;
  //         left: 118px / $vw * 1vw;
  //         transform: scale(0.8);
  //       }
  //       &:nth-of-type(4) {
  //         position: relative;
  //         transform: scale(0.7);
  //         left: 192px / $vw * 1vw;
  //       }
  //       &:nth-of-type(5) {
  //         position: relative;
  //         transform: scale(0.6);
  //         left: 282px / $vw * 1vw;
  //       }
  //       &:nth-of-type(6) {
  //         position: relative;
  //         transform: scale(0.5);
  //         left: 392px / $vw * 1vw;
  //       }
  //       .item {
  //         text-align: center;
  //         background-image: url("../../assets/fullpageImage/item-bg.png");
  //         background-repeat: no-repeat;
  //         background-size: 100% auto;
  //         width: 180px / $vw * 1vw;
  //         height: 180px / $vw * 1vw;
  //         padding: 30px / $vw * 1vw 15px / $vw * 1vw 45px / $vw * 1vw;
  //         box-sizing: border-box;
  //         overflow: hidden;
  //         user-select: none;
  //         cursor: pointer;
  //         & > div {
  //           margin-top: 8px / $vw * 1vw;
  //         }
  //         &:not(:first-child) {
  //           margin-top: -30px / $vw * 1vw;
  //         }
  //         h4 {
  //           display: inline-block;
  //           color: #bdbebf;
  //           font-size: 20px / $vw * 1vw;
  //           margin-bottom: 6px / $vw * 1vw;
  //           font-weight: 500;
  //           margin-bottom: 10px / $vw * 1vw;
  //           text-overflow: ellipsis;
  //           white-space: nowrap;
  //           overflow: hidden;
  //           max-width: 75%;
  //           left: 0;
  //           right: 0;
  //           & + p {
  //             border-top: 2px solid #bdbebf;
  //             width: 95%;
  //             transform: scaleX(1);
  //             transform-origin: center center;
  //             padding-top: 5px;
  //             /*&:before{
  //             content:'';
  //             display: block;
  //             position:absolute;
  //             top:0;
  //             width:100%;
  //             height:2px;
  //             left:0;
  //             transform:scaleX(.9);
  //             transform-origin: center center;
  //             margin-left:-10%;
  //             background-color:#bdbebf;
  //           } */
  //           }
  //           &.linet {
  //             color: #292929;
  //             border-bottom-color: #292929;
  //           }
  //         }
  //         h5 {
  //           font-weight: 500;
  //           color: #bdbebf;
  //           font-size: 19px / $vw * 1vw;
  //           line-height: 1.2;
  //           text-overflow: ellipsis;
  //           white-space: nowrap;
  //           overflow: hidden;
  //           max-width: 75%;
  //           &.linet {
  //             color: #292929;
  //           }
  //         }
  //         p {
  //           color: #bdbebf;
  //           font-size: 13px / $vw * 1vw;
  //           line-height: 1.3;
  //           overflow: hidden;
  //           text-overflow: ellipsis;
  //           white-space: nowrap;
  //         }
  //       }
  //     }
  //   }
  //   .rightbar {
  //     justify-content: flex-start;
  //     flex-direction: row;
  //     transform: translateX(-35px / $vw * 1vw);
  //     & > div {
  //       &:nth-of-type(1) {
  //         position: relative;
  //         left: 0;
  //       }
  //       &:nth-of-type(2) {
  //         position: relative;
  //         transform: scale(0.9);
  //         left: -52px / $vw * 1vw;
  //       }
  //       &:nth-of-type(3) {
  //         position: relative;
  //         left: -118px / $vw * 1vw;
  //         transform: scale(0.8);
  //       }
  //       &:nth-of-type(4) {
  //         position: relative;
  //         transform: scale(0.7);
  //         left: -192px / $vw * 1vw;
  //       }
  //       &:nth-of-type(5) {
  //         position: relative;
  //         transform: scale(0.6);
  //         left: -282px / $vw * 1vw;
  //       }
  //       &:nth-of-type(6) {
  //         position: relative;
  //         transform: scale(0.5);
  //         left: -392px / $vw * 1vw;
  //       }
  //     }
  //   }
  //   .middlebar {
  //     flex: 0 0 15%;
  //     display: flex;
  //     align-items: center;
  //     justify-content: stretch;
  //     box-sizing: border-box;
  //     & > .item {
  //       flex: 1;
  //       width: 100%;
  //       /*  height: 360px / $vw * 1vw; */
  //       background: url("../../assets/fullpageImage/item-bg-full.png") no-repeat;
  //       background-position: center center;
  //       background-size: 110% auto;
  //       padding: 120px / $vw * 1vw 30px / $vw * 1vw;
  //       box-sizing: border-box;
  //       h5 {
  //         font-size: 24px / $vw * 1vw;
  //         color: #f8f9fb;
  //         line-height: 1.5;
  //         text-align: center;
  //       }
  //     }
  //   }
  // }
  h3 {
    // height: 112px / $width * 1vh;
    // // background-image: url("../../assets/fullpageImage/page3_eng_title.png");
    // background-repeat: no-repeat;
    // background-size: auto 58px / $width * 1vh;
    // color: #292929;
    // font-size: 45px / $width * 1vh;
    // font-family: "黑体";
    // text-align: left;
    // padding-top: 43px / $width * 1vh;
    // padding-bottom: 20px / $width * 1vh;
    // margin-left: 43px / $width * 1vh;
    // box-sizing: border-box;
    // position: relative;
    font-size: 48px;
    font-family: FZLanTingHei-DB-GBK;
    font-weight: 400;
    color: #FFFFFF;
    // &:after{
    //   content: "";
    //   display: block;
    //   background-color: #f16a14;
    //   height: 7px / $width * 1vh;
    //   border-radius: 3px;
    //   position: absolute;
    //   bottom: 0;
    // }
    // &::after {
    //   width: 82px / $width * 1vh;
    //   left: 0;
    // }
    // &::before {
    //   width: 22px / $width * 1vh;
    //   left: 94px / $width * 1vh;
    // }
    &.isen {
      background-image: none;
      height: auto;
      padding-top: 0;
    }
  }
  .btn-group {
    text-align: center;
    .more {
      display: inline-block;
      position: relative;
      left: -30px;
      width: 265px / $width * 1vh;
      height: 54px / $width * 1vh;
      border: 1px solid #8d8b8b;
      color: #8d8b8b;
      text-decoration: none;
      text-align: center;
      line-height: 54px / $width * 1vh;
      border-radius: 6px / $width * 1vh;
      background-color: transparent;
    }
  }
}
.count {
  color: #4694d6;
}
@media screen and (max-width: 720px) {
  .page3 {
    padding: 10px / $vw * 1vw 0;
    .type-list-box {
      min-width: auto;
    }
    .btn-group {
      .more {
        left: 0px;
        margin-bottom: 20px;
      }
    }
    h3 {
      background-size: 90% auto;
      margin-top: 20px;
      margin-left: 10px;
    }
  }
}
</style>